import { render, staticRenderFns } from "./PaintTaskManage.vue?vue&type=template&id=7a532c15&scoped=true"
import script from "./PaintTaskManage.vue?vue&type=script&lang=js"
export * from "./PaintTaskManage.vue?vue&type=script&lang=js"
import style0 from "./PaintTaskManage.vue?vue&type=style&index=0&id=7a532c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a532c15",
  null
  
)

export default component.exports